import { gql } from '@apollo/client';

export const SAVE_LEASING_INCOME_SCHEMA = gql`
  mutation saveLeasingIncomeSchema($input: LeasingIncomeSchemaInput!) {
    saveLeasingIncomeSchema(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const UPDATE_LEASING_INCOME_SCHEMA_STATE = gql`
  mutation updateLeasingIncomeSchemaState($id: Int!, $stateId: Int!) {
    updateLeasingIncomeSchemaState(id: $id, stateId: $stateId) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_LEASING_INCOME_SCHEMA_DETAILS = gql`
  mutation saveLeasingIncomeSchemaDetails($schemaId: Int!, $limitsInAbsoluteValues: Boolean!, $details: [LeasingIncomeSchemaDetailInput]!) {
    saveLeasingIncomeSchemaDetails(schemaId: $schemaId, limitsInAbsoluteValues: $limitsInAbsoluteValues, details: $details) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_LEASING_INCOME_SCHEMA_PROPERTIES = gql`
  mutation saveLeasingIncomeSchemaProperties($schemaId: Int!, $properties: [LeasingIncomeSchemaPropertyInput]!) {
    saveLeasingIncomeSchemaProperties(schemaId: $schemaId, properties: $properties) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_LEASING_INCOME_SCHEMA_PARTNERS = gql`
  mutation saveLeasingIncomeSchemaXPartners($schemaId: Int!, $partners: [LeasingIncomeSchemaXPartnerInput]!) {
    saveLeasingIncomeSchemaXPartners(schemaId: $schemaId, partners: $partners) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_LEASING_INCOME_SCHEMA = gql`
  mutation deleteLeasingIncomeSchema($id: Int!) {
    deleteLeasingIncomeSchema(id: $id) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_LEASING_INCOME_SCHEMA_GROUPS = gql`
  mutation saveLeasingIncomeSchemaXGroups($schemaId: Int!, $groups: [LeasingIncomeSchemaXGroupInput]!) {
    saveLeasingIncomeSchemaXGroups(schemaId: $schemaId, groups: $groups) {
      commandId
      correlationId
    }
  }
`;
